export const COMPANY_INTERFIRST_ID = '90174502-24cc-4a96-8d98-c8edb07b80a5';

export const SITE_NAME = 'Lender - Optimus';

export const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
